"use strict";

define('model/sort',['datakit/model'], function (Model) {
  var SORT_FIELD = 'sort';
  var SORT_DIRECTION = 'sort.dir';
  var SORT_DIRECTIONS = {
    ascending: 'asc',
    descending: 'desc'
  };
  var SortModel = Model.extend({
    sortField: function sortField(value) {
      this.set(SortModel.SORT_FIELD, value);
      return this;
    },
    sortDirection: function sortDirection(value) {
      this.set(SortModel.SORT_DIRECTION, value);
      return this;
    },
    toJSON: function toJSON() {
      var data = {};
      if (this.has(SortModel.SORT_FIELD)) {
        data[SORT_FIELD] = this.get(SORT_FIELD);
      }
      if (this.has(SortModel.SORT_DIRECTION) && SORT_DIRECTIONS[this.get(SortModel.SORT_DIRECTION)]) {
        data[SORT_DIRECTION] = SORT_DIRECTIONS[this.get(SortModel.SORT_DIRECTION)];
      }
      return data;
    }
  }, {
    SORT_FIELD: 'sort',
    SORT_DIRECTION: 'sortDirection',
    ASCENDING: 'ascending',
    DESCENDING: 'descending',
    createWithSort: function createWithSort(fieldValue, direction) {
      return new this().sortField(fieldValue).sortDirection(direction || SortModel.ASCENDING);
    }
  });
  return SortModel;
});

